<div class="position-relative message mt-1 thread-input-group threads" [ngClass]="{'input-group': !editMode}" data-cy="manager-comment-input">
    @if (!hideTextareaPlaceholder){
        <div class="thread-textarea-placeholder pt-4 pb-3">
              <textarea (focus)="hideTextareaPlaceholder = true" #newThreadInput 
                        placeholder="{{'taskbook.backlog.manager_comment_placeholder' | translate}}"
                        class="form-control comment-input input-initial-state"
                        aria-describedby="anonymous-addon"></textarea>
        </div>
    } 
    @else{
        <!--    edit mode -->
        <tm-rich-text-area [cdkTrapFocusAutoCapture]="hideTextareaPlaceholder" [cdkTrapFocus]="hideTextareaPlaceholder" 
                            [(content)]="rtaContent"
                            (contentChange)="onContentChange($event)"
                            [threadAuthors]="commentAuthors"
                            [placeholderText]="'taskbook.backlog.manager_comment_placeholder' | translate"
                            [customStyles]="{'width': '100%', 'background-color': 'white', 'font-size': '14px'}"
                            class="tm-rich-text-area" #richTextAreaComponent></tm-rich-text-area>

        <div class="textarea-actions">
            <div class="d-flex justify-content-end align-items-baseline">
                <div class="thread-to-edit-actions">
                    <button (click)="save()" 
                            [disabled]="emptyContent()"
                            class="thread-to-edit-actions-update" 
                            [ngClass]="{'disabled': emptyContent()}">
                        {{'post' | translate }} <i class="far fa-check"></i>
                    </button>
                    <button (click)="cancelUpdates()" class="ps-2 align-middle thread-to-edit-actions-cancel">
                        <i class="far fa-times-circle"></i>
                    </button>
                </div>
            </div>
        </div>
    }
</div>